import { ParametroSimulacion } from '../respuestas/parametroSim.model';

const modificarRangoFinalSegunCondicion = (data: ParametroSimulacion) => {
  // Si posee una condicion y el rango final es null (osea digamos, desde rango inicial en adelante) se setea Infinity para realizar comparaciones en el armado del resumen.
  let rangoFinal = null;
  if (data.condicion) {
    if (!data.rangoFinal) {
      rangoFinal = 9999999999999999999;
    } else {
      rangoFinal = data.rangoFinal;
    }
  }

  return { rangoFinal };
};

export const parametroSimAdapter = (data: ParametroSimulacion[]) => {
  return data.map((p) => {
    return {
      ...p,

      ...modificarRangoFinalSegunCondicion(p),
    };
  });
};
